import { useEffect, useState } from 'react';
import { adminApi } from '../../adminApi';
import { IconSettings, IconCheck } from '../../components/Icon';
import { AdminHeader } from './ui';

export default function AdminSettings() {
  const [user,setUser]=useState('admin'); const [pass,setPass]=useState(''); const [msg,setMsg]=useState<string|null>(null);
  useEffect(()=>{ adminApi.settings().then(r=>{ if(r.status===200) setUser(r.data?.admin?.username||'admin'); }); },[]);
  const save=async()=>{
    const r=await adminApi.updateSettings({username:user, password: pass});
    setMsg(r.status===200 ? 'Saved — new credentials active. Re-login required if you changed password.' : (r.data?.message||'Failed'));
    setPass('');
  };
  return (
    <div className="max-w-xl">
      <AdminHeader icon={IconSettings} title="Settings" subtitle={<>Rotate admin credentials. Password ≥6 chars. Stored bcrypt in <code>admin_users</code>.</>} />
      {msg && <div className="mb-4 px-6 py-4 rounded-xl bg-[color:var(--color-ok)]/15 border border-[color:var(--color-ok)]/30 text-sm">{msg}</div>}
      <div className="glass p-6 mt-6">
        <label className="block text-xs uppercase tracking-widest text-[color:var(--color-ink-faint)]">Username</label>
        <input value={user} onChange={e=>setUser(e.target.value)} className="mt-1 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-6 py-4 text-sm" />
        <label className="block mt-4 text-xs uppercase tracking-widest text-[color:var(--color-ink-faint)]">New password (leave blank to keep)</label>
        <input type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••" className="mt-1 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-6 py-4 text-sm" />
        <button onClick={save} className="btn btn-primary w-full mt-6 justify-center"><IconCheck width={16} height={16}/> Save changes</button>
        <div className="text-xs text-[color:var(--color-ink-faint)] mt-3">You will be logged out if password changes — login again with MFA.</div>
      </div>
      <div className="glass p-6 mt-6">
        <h3 className="font-bold">Security</h3>
        <ul className="text-sm text-[color:var(--color-ink-dim)] mt-2 list-disc pl-5 space-y-1">
          <li>TOTP via <code>TotpService</code> — QR on first login, 30s window.</li>
          <li>Admin tokens 12h, HMAC required on every call (<code>vpnee-web</code>).</li>
          <li>Change <code>admin_users</code> password regularly.</li>
        </ul>
      </div>
    </div>
  );
}
